import http from "infra/http";
import { useMutation } from "react-query";
import URL from "core/resources/urls";

export interface useLinkJobOnGroupProps {
  recurringJobGroupId: string;
  jobIds: string[];
}

export interface useLinkJobOnGroupResponse {
  recurringJobGroupId: string;
  jobIds: string[];
}

export default function useLinkJobOnGroup() {
  return useMutation({
    mutationKey: [
      URL.RECURRING_JOB_GROUP.LINK_JOB_ON_GROUP("recurringJobGroupId"),
    ],
    mutationFn: async ({
      recurringJobGroupId,
      jobIds,
    }: useLinkJobOnGroupProps) => {
      const response = await http.post<useLinkJobOnGroupResponse, any>(
        `${URL.RECURRING_JOB_GROUP.LINK_JOB_ON_GROUP(recurringJobGroupId)}`,
        {
          jobIds,
        },
      );

      return response.data;
    },
  });
}
